import React, { useState } from 'react'
import { PatientPreferencesMenuBase } from '../_base'
import { Button } from '@blueprinthq/joy'
import { Box, Flex } from '@chakra-ui/react'
import { ClientStatusBuckets } from '@constants/clientStatusBuckets'
import { useRouteMatch } from 'react-router-dom'
import { useExperienceManager } from '@hooks'

import { useSessionControllerPostSession } from '~/clinician-api'
import { UploadModalV2 } from '@handlers/sessions/components/upload-modal-v2'
import { useStoreActions, useStoreState } from 'easy-peasy'
import { StartNewSessionMenu } from '@handlers/sessions/components/start-new-session-menu'

export default function PatientPreferencesMenuWrapper(props: any) {
  const { user } = useStoreState((state: any) => state.auth)
  const { patient } = props
  const {
    isExtension,
    isPlusPlanEnabled,
    documentationAutomationFreeTierSessionLimitReached,
    isAdmin,
    isDocumentationAutomationEnabled
  } = useExperienceManager()
  const [uploadModalOpen, setUploadModalOpen] = useState(false)
  let patientMatch: any = useRouteMatch('/patient/:clientId')
  let preEnrollMatch: any = useRouteMatch('/pre-enroll-patient/:clientId')
  const match = patientMatch || preEnrollMatch || {}

  const openDocAutomationPlanModal = useStoreActions(
    (actions: any) => actions.modals.manageScribePlan.openModal
  )

  const openDocAutomationSessionLimitReachedModal = useStoreActions(
    (actions: any) => actions.modals.docAutomationSessionLimitReached.openModal
  )

  const showSessions =
    patient.status === ClientStatusBuckets.ACTIVE ||
    patient.status === ClientStatusBuckets.INVITE_SENT

  const { mutateAsync: createSessionDraft } = useSessionControllerPostSession()

  const sessionConfig = {
    patientId: match.params?.clientId,
    isChime: false,
    isExtension,
    extensionInitiatedFrom: isExtension ? document.referrer : null,
    resumeInProgress: true,
    isDictation: false,
    isAssistEnabled: isPlusPlanEnabled
  }

  const handleStartSession = async ({
    configAdditions = {},
    url
  }: {
    configAdditions?: any
    url: string
  }) => {
    const newTab = window.open('', '_blank')

    if (!newTab) {
      console.error('Failed to open new tab', newTab)
      return
    }

    const sessionDraft = await createSessionDraft({
      data: { ...sessionConfig, ...configAdditions }
    })

    newTab.location = `${url}/session/${sessionDraft.id}`
  }

  const handleUploadClick = () => {
    if (documentationAutomationFreeTierSessionLimitReached) {
      if (isAdmin) {
        openDocAutomationPlanModal({
          clinicId: user!.clinic_id
        })
      } else {
        openDocAutomationSessionLimitReachedModal()
      }
    } else {
      setUploadModalOpen(true)
    }
  }

  return (
    <Flex align="center">
      <PatientPreferencesMenuBase {...props} />
      {showSessions &&
        (!isDocumentationAutomationEnabled ? (
          <Button
            id="pendo-start-session-tag"
            paddingLeft="37.5px"
            paddingRight="37.5px"
            marginLeft="24px"
            _focus={{
              boxShadow: 'none'
            }}
            onClick={() =>
              handleStartSession({
                url: `/patient/${match.params?.clientId}`
              })
            }
          >
            New Session
          </Button>
        ) : (
          <Box ml="16px">
            <StartNewSessionMenu
              clientId={match.params?.clientId}
              id="pendo-start-session-tag"
              onInPersonClick={() =>
                handleStartSession({
                  url: `/patient/${match.params?.clientId}`
                })
              }
              onDictationClick={() =>
                handleStartSession({
                  configAdditions: { isDictation: true },
                  url: `/patient/${match.params?.clientId}/dictate`
                })
              }
              onUploadClick={handleUploadClick}
              onTelehealthClick={() =>
                handleStartSession({
                  configAdditions: { isTelehealth: true, isDailyco: true },
                  url: `/patient/${match.params?.clientId}/telehealth`
                })
              }
            />
          </Box>
        ))}
      <UploadModalV2
        open={uploadModalOpen}
        onClose={() => setUploadModalOpen(false)}
      />
    </Flex>
  )
}
